
<template lang="pug">
.cnmn-field
  slot(
    :touch="touch"
    :touched="touched"
  )
</template>

<script>
import {vueGetUid} from '@/helpers/vue-component-inspect'

export default {
  inject:{
    setFormState:    {default: () => {}},
    queryFormState:  {default: () => ({})},
    deleteFormState: {default: () => {}},
  },

  props: {
    name: {type: String, default() {return '#' + vueGetUid(this)}},
  },

  computed: {
    stateKey() {
      return 'field:' + this.name
    },
  },

  data() {
    return {
      touched: false,
    }
  },

  created() {
    this.setFormState(this.stateKey, {field: this})
  },

  beforeDestroy() {
    this.deleteFormState(this.stateKey)
  },

  methods: {
    touch() {
      this.touched = true
    },
  },
}
</script>
